import { Grid } from "@mui/material";
import Footer from "../../common/Footer";
import HeaderSec from "../../common/HeaderSec";
import KalpavrukshaVaibhava from "../sections/KalpavrukshaVaibhava";
import AllotmentSection from "../sections/AllotmentSection";
import NeighbourhoodHospitals from "../sections/NeighbourhoodHospitals";
import KiadbIndustrialArea from "../sections/KiadbIndustrialArea";
import NeighbourhoodEducation from "../sections/NeighbourhoodEducation";


const OurProject = () => {
  return (
    <Grid>
      <HeaderSec />
      <KalpavrukshaVaibhava />
      <AllotmentSection />
      <NeighbourhoodHospitals />
      <KiadbIndustrialArea />
      <NeighbourhoodEducation />
      <Footer />
    </Grid>
  );
};

export default OurProject;
